import { useAuth } from "@/providers/auth-provider";
import { cn } from "@/lib/utils";

export function UserAvatar({ className, textClass }: { className: string; textClass: string }) {
  const { user } = useAuth();

  if (user.picture) {
    return (
      <img
        src={user.picture}
        alt={user.name}
        referrerPolicy="no-referrer"
        className={cn("rounded-full shrink-0 object-cover", className)}
      />
    );
  }
  return (
    <div
      className={cn(
        "rounded-full bg-sidebar-accent text-sidebar-primary flex items-center justify-center font-semibold shrink-0",
        className,
        textClass,
      )}
    >
      {user.name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .slice(0, 2)
        .toUpperCase()}
    </div>
  );
}
